module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logincontainer"
  }, [_c('div', {
    staticClass: "logincontainerEntureWidth"
  }, [_c('div', {
    staticClass: "bgitem"
  }), _vm._v(" "), _c('div', {
    staticClass: "logincontainerItem"
  }, [_c('el-menu', {
    staticClass: "elmenu",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "登录"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "注册"
    }
  }, [_vm._v("注册")])], 1), _vm._v(" "), (_vm.activeIndex == '登录') ? _c('div', {
    staticClass: "leftLogin"
  }, [(!_vm.gobackPasswordFlag) ? [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "108px",
      "model": _vm.loginFormdata,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "nameOrPhone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "用户名/手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.loginFormdata.nameOrPhone),
      callback: function($$v) {
        _vm.$set(_vm.loginFormdata, "nameOrPhone", $$v)
      },
      expression: "loginFormdata.nameOrPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "请输入密码",
      "show-password": ""
    },
    model: {
      value: (_vm.loginFormdata.password),
      callback: function($$v) {
        _vm.$set(_vm.loginFormdata, "password", $$v)
      },
      expression: "loginFormdata.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "loginFont tipsCommon",
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("\n                登录\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "forget tipsCommon"
  }, [_c('div', {
    staticClass: "forgetpassword",
    on: {
      "click": function($event) {
        return _vm.forgetpasswordClickFun()
      }
    }
  }, [_vm._v("\n                  忘记密码\n                ")])])], 1)] : [_c('el-form', {
    ref: "ruleForm3",
    attrs: {
      "label-width": "108px",
      "model": _vm.gobackPasswordData,
      "rules": _vm.rules3
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "upd_phone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "请输入中国大陆手机号",
      "clearable": "",
      "disabled": _vm.ensureCodeFlag
    },
    model: {
      value: (_vm.gobackPasswordData.upd_phone),
      callback: function($$v) {
        _vm.$set(_vm.gobackPasswordData, "upd_phone", $$v)
      },
      expression: "gobackPasswordData.upd_phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码",
      "prop": "upd_code"
    }
  }, [_c('el-input', {
    staticClass: "inputidecode",
    staticStyle: {
      "width": "111px",
      "height": "34px"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "clearable": "",
      "disabled": _vm.ensureCodeFlag
    },
    model: {
      value: (_vm.gobackPasswordData.upd_code),
      callback: function($$v) {
        _vm.$set(_vm.gobackPasswordData, "upd_code", $$v)
      },
      expression: "gobackPasswordData.upd_code"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.ensureCodeFlag
    },
    on: {
      "click": function($event) {
        return _vm.getidecodeFun(_vm.gobackPasswordData.upd_phone)
      }
    }
  }, [_vm._v(_vm._s(_vm.getidecodeData))])], 1), _vm._v(" "), (_vm.ensureCodeFlag) ? [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "upd_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "请输入密码",
      "show-password": ""
    },
    model: {
      value: (_vm.gobackPasswordData.upd_password),
      callback: function($$v) {
        _vm.$set(_vm.gobackPasswordData, "upd_password", $$v)
      },
      expression: "gobackPasswordData.upd_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码",
      "prop": "upd_password2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "请再次确认密码",
      "show-password": ""
    },
    model: {
      value: (_vm.gobackPasswordData.upd_password2),
      callback: function($$v) {
        _vm.$set(_vm.gobackPasswordData, "upd_password2", $$v)
      },
      expression: "gobackPasswordData.upd_password2"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loginFont tipsCommon",
    on: {
      "click": function($event) {
        return _vm.submitForm3('ruleForm3')
      }
    }
  }, [_vm._v("\n                确定\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "forget tipsCommon"
  }, [_c('div', {
    staticClass: "forgetpassword",
    on: {
      "click": function($event) {
        return _vm.gobackForLoginFun()
      }
    }
  }, [_vm._v("\n                  返回登录\n                ")])])], 2)]], 2) : _vm._e(), _vm._v(" "), (_vm.activeIndex == '注册') ? _c('div', {
    staticClass: "rightRegister"
  }, [_c('el-form', {
    ref: "ruleForm2",
    attrs: {
      "label-width": "108px",
      "model": _vm.registFormdata,
      "rules": _vm.rules2
    }
  }, [(_vm.registFormdata.is_danwei != 1) ? _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "reg_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "用户名",
      "clearable": ""
    },
    model: {
      value: (_vm.registFormdata.reg_name),
      callback: function($$v) {
        _vm.$set(_vm.registFormdata, "reg_name", $$v)
      },
      expression: "registFormdata.reg_name"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "单位名",
      "prop": "reg_name2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "单位名称",
      "clearable": ""
    },
    model: {
      value: (_vm.registFormdata.reg_name2),
      callback: function($$v) {
        _vm.$set(_vm.registFormdata, "reg_name2", $$v)
      },
      expression: "registFormdata.reg_name2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "reg_password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "请输入密码",
      "show-password": ""
    },
    model: {
      value: (_vm.registFormdata.reg_password),
      callback: function($$v) {
        _vm.$set(_vm.registFormdata, "reg_password", $$v)
      },
      expression: "registFormdata.reg_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码",
      "prop": "reg_password2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "请再次确认密码",
      "show-password": ""
    },
    model: {
      value: (_vm.registFormdata.reg_password2),
      callback: function($$v) {
        _vm.$set(_vm.registFormdata, "reg_password2", $$v)
      },
      expression: "registFormdata.reg_password2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "reg_phone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px",
      "height": "40px"
    },
    attrs: {
      "placeholder": "请输入中国大陆手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.registFormdata.reg_phone),
      callback: function($$v) {
        _vm.$set(_vm.registFormdata, "reg_phone", $$v)
      },
      expression: "registFormdata.reg_phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码",
      "prop": "reg_code"
    }
  }, [_c('el-input', {
    staticClass: "inputidecode",
    staticStyle: {
      "width": "111px",
      "height": "34px"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "clearable": ""
    },
    model: {
      value: (_vm.registFormdata.reg_code),
      callback: function($$v) {
        _vm.$set(_vm.registFormdata, "reg_code", $$v)
      },
      expression: "registFormdata.reg_code"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.getidecodeFun(_vm.registFormdata.reg_phone)
      }
    }
  }, [_vm._v(_vm._s(_vm.getidecodeData))])], 1), _vm._v(" "), _c('div', {
    staticClass: "loginFont tipsCommon",
    on: {
      "click": function($event) {
        return _vm.submitForm2('ruleForm2')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.loading ? '注册中...' : '注册') + "\n              \n            ")])], 1)], 1) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e3206c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/login/Login.vue
// module id = 1425
// module chunks = 0